import DonutMetricCard from "./DonutMetricCard";

const COLORS = {
  answered: "#0FA9C0",
  inbound: "#5BA0E6",
  outbound: "#F4B860",
  dropped: "#9AA4B2",
  booked: "#21B37B",
  requested: "#7C8CF8",
  info: "#CBD5E1",
};

export default function CallDistributionPanel({ stats = {}, onNavigate }) {
  const totalCalls = Number(stats.total_calls || 0);
  const inboundCalls = Number(stats.inbound_calls || 0);
  const outboundCalls = Number(stats.outbound_calls || 0);
  const bookedCalls = Number(stats.total_bookings || stats.booked_calls || 0);
  const requestedCalls = Number(stats.total_booking_requests || stats.requested_calls || 0);
  const droppedCalls = Number(stats.dropped_calls || 0);
  const infoCalls = Math.max(0, totalCalls - bookedCalls - requestedCalls - droppedCalls);

  return (
    <section className="dashboard-distribution-panel" aria-label="Call distribution">
      <DonutMetricCard
        title="Direction Mix"
        value={totalCalls.toLocaleString()}
        subtitle="calls"
        segments={[
          { key: "inbound", label: "Inbound", value: inboundCalls, color: COLORS.inbound },
          { key: "outbound", label: "Outbound", value: outboundCalls, color: COLORS.outbound },
        ]}
        legend={[
          { key: "inbound", label: `Inbound ${inboundCalls.toLocaleString()}`, color: COLORS.inbound },
          { key: "outbound", label: `Outbound ${outboundCalls.toLocaleString()}`, color: COLORS.outbound },
        ]}
        footer={droppedCalls ? `${droppedCalls.toLocaleString()} dropped under 10s` : "No dropped calls in view"}
        onClick={() => onNavigate?.({})}
      />
      <DonutMetricCard
        title="Outcome Mix"
        value={bookedCalls.toLocaleString()}
        subtitle="booked"
        segments={[
          { key: "booked", label: "Booked", value: bookedCalls, color: COLORS.booked },
          { key: "requested", label: "Requested", value: requestedCalls, color: COLORS.requested },
          { key: "dropped", label: "Dropped", value: droppedCalls, color: COLORS.dropped },
          { key: "info", label: "Info", value: infoCalls, color: COLORS.info },
        ]}
        legend={[
          { key: "booked", label: `Booked ${bookedCalls.toLocaleString()}`, color: COLORS.booked },
          { key: "requested", label: `Requested ${requestedCalls.toLocaleString()}`, color: COLORS.requested },
          { key: "dropped", label: `Dropped ${droppedCalls.toLocaleString()}`, color: COLORS.dropped },
        ]}
        footer={`${infoCalls.toLocaleString()} informational calls`}
        onClick={() => onNavigate?.({ status: "booked" })}
      />
    </section>
  );
}
